import { render, staticRenderFns } from "./updateinitialbalance.vue?vue&type=template&id=3fa92749&"
import script from "./updateinitialbalance.vue?vue&type=script&lang=js&"
export * from "./updateinitialbalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports